import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=c5aa32de&scoped=true&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&id=c5aa32de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5aa32de",
  null
  
)

export default component.exports